export class Alert {
	type: AlertType;
	message: string;
}

export enum AlertType {
	Success,
	Error,
	Info,
	Warning
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/alert.ts